import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { IStageOptionsMessages } from './StageOptionsMessages.interface';

export default class StageOptionsMessages implements IStageOptionsMessages {
  id: string;
  onEnter: boolean;
  onStale: boolean;

  static build = (data: IStageOptionsMessages) => new StageOptionsMessages(data);
  static blank = () => new StageOptionsMessages();

  /**
   * Constructor
   * @param {IStageOptionsMessages} data
   */
  constructor(data?: IStageOptionsMessages) {
    this.id = toUUID(data?.id) || uuid();
    this.onEnter =
      data?.enter === true || data?.enter === false ? data?.enter : data?.onEnter === true;
    this.onStale =
      data?.stale === true || data?.stale === false ? data?.stale : data?.onStale === true;
  }
}
